module.exports = "/images/logo-20-m.svg?78af30569538dafc247d2c11acbc0a5d";